import type {
    IAccountData,
    IAssignedGuardianSubAccount,
    IGuardianTermsVersion,
} from '@/typings/account'

export const getAssignedSubAccountIds = (accountData: IAccountData | null): string[] => {
    if (!accountData) {
        return []
    }

    if (accountData.assignedSubaccounts?.length) {
        return accountData.assignedSubaccounts.map(({ subaccountId }) => subaccountId)
    }

    return accountData.assignSubaccounts || []
}

export const getCurrentTerms = (
    assignedSubAccount: IAssignedGuardianSubAccount | null | undefined,
): IGuardianTermsVersion | null => {
    return assignedSubAccount?.terms.find((term) => term.isCurrent) || null
}

export const hasAcceptedCurrentTerms = (
    assignedSubAccount: IAssignedGuardianSubAccount | null | undefined,
): boolean => {
    if (!assignedSubAccount) {
        return false
    }

    const currentTerms = getCurrentTerms(assignedSubAccount)

    return Boolean(assignedSubAccount.currentTermsAcceptedAt || currentTerms?.acceptedAt)
}

export const requiresCurrentTermsAcceptance = (
    assignedSubAccount: IAssignedGuardianSubAccount | null | undefined,
): boolean => {
    if (!assignedSubAccount?.isEnabled) {
        return false
    }

    const currentTerms = getCurrentTerms(assignedSubAccount)

    return Boolean(currentTerms && !hasAcceptedCurrentTerms(assignedSubAccount))
}

export const findAssignedSubAccount = (
    accountData: IAccountData | null,
    subAccountId: string | null | undefined,
): IAssignedGuardianSubAccount | null => {
    if (!subAccountId) {
        return null
    }

    return (
        accountData?.assignedSubaccounts?.find(
            (assignedSubAccount) => assignedSubAccount.subaccountId === subAccountId,
        ) || null
    )
}

export const findFirstSubAccountRequiringTermsAcceptance = (
    accountData: IAccountData | null,
): IAssignedGuardianSubAccount | null => {
    return accountData?.assignedSubaccounts?.find(requiresCurrentTermsAcceptance) || null
}
